import React from "react";

import { useFeatures } from "components/FeatureFlag";

function NoProcessMessage() {
  const ff = useFeatures("shared-resources");

  return (
    <div>
      It looks like you don&apos;t have any processes yet. To begin sharing
      processes, create one first! You can find a{" "}
      <a
        className="underline_on_hover"
        href={ff?.modal?.processHowtoUrl || "https://help.myhubly.com"}
        target="_blank"
        rel="noopener noreferrer"
        data-test="no-processes-message-help-link"
      >
        step-by-step guide in our help center
      </a>{" "}
      on how to create your first process.
    </div>
  );
}

export default NoProcessMessage;
